import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface TopBarProps {
  title: string;
  showBack?: boolean;
}

export function TopBar({ title, showBack = true }: TopBarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Ne pas afficher le bouton retour sur la page d'accueil
  const isHome = location.pathname === '/';
  const shouldShowBack = showBack && !isHome && window.history.length > 1;

  return (
    <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-40">
      <div className="flex items-center h-14 px-4">
        {shouldShowBack && (
          <button
            onClick={() => navigate(-1)}
            className="mr-3 p-2 -ml-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label="Retour"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <h1 className="text-lg font-semibold truncate">{title}</h1>
      </div>
    </header>
  );
}
